import Collaborator from "./Collaborator";
import PersonalData from "./PersonalData";
import Workflow from "./Workflow";

export default class Organization {
  constructor({
    id = Number.NaN,
    name = "",
    avatar = null,
    logo = null,
    description = "",
    contact = "",
    cosmoformDefaultMessage = "",
    collaborators = [],
    enoxa = null,
    personalDatas = [],
    hasQuestionTemplates,
    wizideeLogin = "",
    wizideePassword = "",
    yousignWebhookUrl = "",
    yousignWorkspaceId = "",
    workflows = [],
    notificationLifetime = null,
  } = {}) {
    this.id = id;
    this.name = name;
    this.avatar = avatar;
    this.logo = logo;
    this.description = description;
    this.cosmoformDefaultMessage = cosmoformDefaultMessage;
    this.contact = contact;
    this.wizideeLogin = wizideeLogin;
    this.yousignWebhookUrl = yousignWebhookUrl;
    this.yousignWorkspaceId = yousignWorkspaceId;
    this.wizideePassword = wizideePassword;
    this.notificationLifetime = notificationLifetime;
    this.collaborators = collaborators
      ? collaborators.map((collaborator) => new Collaborator(collaborator))
      : [];
    this.enoxa = enoxa;
    this.hasQuestionTemplates = hasQuestionTemplates;
    this.personalDatas = personalDatas?.length
      ? personalDatas.map((p) => new PersonalData({ ...p }))
      : [];
    this.workflows = workflows?.length
      ? workflows.map((w) => new Workflow(w))
      : [];
  }
}
